module.exports = __webpack_public_path__ + "static/media/markdown.1f576b53.md";